var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cadastroOriginal
    ? _c(
        "div",
        [
          _c(
            "el-tabs",
            {
              staticClass: "tabs",
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.abaAtiva,
                callback: function($$v) {
                  _vm.abaAtiva = $$v
                },
                expression: "abaAtiva"
              }
            },
            [
              (_vm.isOnerosoGroup || _vm.isProcessoFisico || _vm.isReurb) &&
              !_vm.isGeoCadastro
                ? _c(
                    "el-tab-pane",
                    { staticClass: "tab", attrs: { name: "qualificacao" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("div", { staticClass: "label" }, [_vm._v("Geral  ")])
                      ]),
                      _vm.isRoraima
                        ? _c("informacoes-qualificacao-rr", {
                            attrs: {
                              qualificacao: _vm.cadastroOriginal.qualificacao,
                              tipo: _vm.processo.tipo.nome,
                              dataCadastro: _vm.processo.dataCadastro,
                              cadastroOriginal: _vm.cadastroOriginal,
                              pessoas: _vm.processo.pessoas,
                              dataRetificacao: _vm.processo.dataRetificacao
                            }
                          })
                        : _vm._e(),
                      _vm.cadastroOriginal.tipo === "NAO_ONEROSO" ||
                      _vm.isReurb ||
                      _vm.isProcessoFisico
                        ? _c("informacoes-qualificacao", {
                            attrs: {
                              qualificacao: _vm.cadastroOriginal.qualificacao,
                              tipo: _vm.tipoCadastro(_vm.processo.tipo.nome),
                              dataCadastro: _vm.processo.dataCadastro,
                              cadastroOriginal: _vm.cadastroOriginal,
                              pessoas: _vm.processo.pessoas,
                              compararQualificacao:
                                _vm.compararRetificacoes.mudouQualificacaoDTO,
                              dataRetificacao: _vm.processo.dataRetificacao,
                              isProcessoFisico: _vm.isProcessoFisico,
                              idProcesso: _vm.processo.id
                            }
                          })
                        : _vm._e(),
                      _vm.cadastroOriginal.tipo === "ONEROSO"
                        ? _c("informacoes-qualificacao-oneroso", {
                            attrs: {
                              qualificacao: _vm.cadastroOriginal.qualificacao,
                              tipo: _vm.processo.tipo.nome,
                              dataCadastro: _vm.processo.dataCadastro,
                              pessoas: _vm.processo.pessoas,
                              compararQualificacaoOneroso:
                                _vm.compararRetificacoes.mudouQualificacaoDTO,
                              dataRetificacao: _vm.processo.dataRetificacao
                            }
                          })
                        : _vm._e(),
                      _vm.cadastroOriginal.tipo === "CERTIDAO_TITULO"
                        ? _c("informacoes-qualificacao-certidao", {
                            attrs: {
                              qualificacao: _vm.cadastroOriginal.qualificacao,
                              tipo: _vm.processo.tipo.nome,
                              dataCadastro: _vm.processo.dataCadastro,
                              pessoas: _vm.processo.pessoas,
                              compararQualificacaoCertidao:
                                _vm.compararRetificacoes.mudouQualificacaoDTO,
                              dataRetificacao: _vm.processo.dataRetificacao
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isTeqGroup && !_vm.isGeoCadastro
                ? _c(
                    "el-tab-pane",
                    { staticClass: "tab", attrs: { name: "geralTeq" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("div", { staticClass: "label" }, [_vm._v("Geral  ")])
                      ]),
                      _c("informacoes-qualificacao", {
                        attrs: {
                          cadastroOriginal: _vm.cadastroOriginal,
                          qualificacao: _vm.cadastroOriginal.qualificacao,
                          tipo: _vm.processo.tipo.nome,
                          dataCadastro: _vm.processo.dataCadastro,
                          compararQualificacao:
                            _vm.compararRetificacoes.mudouQualificacaoDTO,
                          dataRetificacao: _vm.processo.dataRetificacao,
                          pessoas: _vm.processo.pessoas
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isGeoCadastro
                ? _c(
                    "el-tab-pane",
                    { staticClass: "tab", attrs: { name: "cadastrante" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(
                            _vm._s(_vm.isBahia ? "Executor" : "Cadastrante") +
                              "  "
                          )
                        ])
                      ]),
                      !_vm.isTeqGroup
                        ? _c("informacoes-cadastrante", {
                            attrs: {
                              cadastrante: _vm.cadastrante,
                              isOnerosoGroup: _vm.isOnerosoGroup,
                              compararCadastrante:
                                _vm.compararRetificacoes.mudouCadastranteDTO,
                              tipoProcesso: _vm.tipoProcesso,
                              isProcessoFisico: _vm.isProcessoFisico
                            }
                          })
                        : _vm._e(),
                      _vm._l(_vm.cadastrante.membrosComunidade, function(
                        membro,
                        index
                      ) {
                        return _c("div")
                      }),
                      _vm.isTeqGroup
                        ? _c("app-teq-group", {
                            attrs: {
                              cadastroOriginal: _vm.cadastroOriginal,
                              cadastrante: _vm.cadastrante,
                              "show-membro-endereco": true,
                              compararTeqGroup:
                                _vm.compararRetificacoes.mudouCadastranteDTO
                            }
                          })
                        : _vm._e(),
                      _vm.cadastrante.documentos &&
                      _vm.cadastrante.documentos.length > 0
                        ? _c("listagem-documentos", {
                            attrs: {
                              documentos: _vm.cadastrante.documentos,
                              protocoloCadastroOriginal:
                                _vm.cadastroOriginal.protocolo,
                              ownerDocumento: "CADASTRANTE",
                              compararDocumentos:
                                _vm.compararRetificacoes.mudouCadastranteDTO
                                  .mudouDocumentosCadastrante,
                              versaoCadastro: _vm.versaoCadastro,
                              isCadastroPendente: _vm.isCadastroPendente
                            }
                          })
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              !_vm.isGeoCadastro
                ? _c(
                    "el-tab-pane",
                    { staticClass: "tab", attrs: { name: "interessado" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("Interessado  ")
                        ])
                      ]),
                      !_vm.isMultiplosInteressados
                        ? _c(
                            "div",
                            [
                              _c("informacoes-interessado", {
                                attrs: {
                                  interessado: _vm.interessado,
                                  cadastroOriginal: _vm.cadastroOriginal,
                                  isOnerosoGroup: _vm.isOnerosoGroup,
                                  isReurb: _vm.isReurb,
                                  compararInteressado:
                                    _vm.compararRetificacoes
                                      .mudouInteressadoDTO,
                                  versaoCadastro: _vm.versaoCadastro
                                }
                              }),
                              _vm.interessado.documentos &&
                              _vm.interessado.documentos.length > 0
                                ? _c("listagem-documentos", {
                                    attrs: {
                                      documentos: _vm.interessado.documentos,
                                      protocoloCadastroOriginal:
                                        _vm.cadastroOriginal.protocolo,
                                      ownerDocumento: "INTERESSADO",
                                      compararDocumentos:
                                        _vm.compararRetificacoes
                                          .mudouInteressadoDTO
                                          .mudouDocumentosInteressado,
                                      versaoCadastro: _vm.versaoCadastro,
                                      isCadastroPendente: _vm.isCadastroPendente
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c(
                                "el-collapse",
                                _vm._l(_vm.interessadosLista, function(
                                  interessado,
                                  index
                                ) {
                                  return _c(
                                    "el-collapse-item",
                                    {
                                      key: index,
                                      attrs: {
                                        title:
                                          interessado.pessoa.pessoaFisica.nome
                                      }
                                    },
                                    [
                                      _c("informacoes-interessado", {
                                        attrs: {
                                          interessado: interessado,
                                          cadastroOriginal:
                                            _vm.cadastroOriginal,
                                          isOnerosoGroup: _vm.isOnerosoGroup,
                                          isReurb: _vm.isReurb,
                                          compararInteressado:
                                            _vm.compararRetificacoes
                                              .mudouInteressadoDTO,
                                          versaoCadastro: _vm.versaoCadastro
                                        }
                                      }),
                                      _vm.isReurb
                                        ? _c("app-divider", {
                                            attrs: { label: "Assinatura" }
                                          })
                                        : _vm._e(),
                                      _vm.isReurb
                                        ? _c("assinatura-mobile", {
                                            attrs: {
                                              assinatura: _vm.assinatura,
                                              isAssinaturaInserida:
                                                interessado.isAssinaturaInserida
                                            }
                                          })
                                        : _vm._e(),
                                      interessado.documentos &&
                                      interessado.documentos.length > 0
                                        ? _c("listagem-documentos", {
                                            attrs: {
                                              documentos:
                                                interessado.documentos,
                                              protocoloCadastroOriginal:
                                                _vm.cadastroOriginal.protocolo,
                                              ownerDocumento: "INTERESSADOS",
                                              idInteressado:
                                                interessado._id ||
                                                interessado.id,
                                              compararDocumentos:
                                                _vm.compararRetificacoes
                                                  .mudouInteressadoDTO
                                                  .mudouDocumentosInteressado,
                                              versaoCadastro:
                                                _vm.versaoCadastro,
                                              isCadastroPendente:
                                                _vm.isCadastroPendente
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                    ]
                  )
                : _vm._e(),
              _vm.isTeqGroup &&
              _vm.beneficiarios.length > 0 &&
              !_vm.isGeoCadastro
                ? _c(
                    "el-tab-pane",
                    { staticClass: "tab", attrs: { name: "beneficiarios" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("Beneficiários  ")
                        ])
                      ]),
                      _c("informacoes-beneficiarios", {
                        attrs: {
                          beneficiarios: _vm.beneficiarios,
                          cadastroOriginal: _vm.cadastroOriginal,
                          isBeneficiariosDiferentes:
                            _vm.compararRetificacoes.mudouBeneficiarios
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isGeoCadastro
                ? _c(
                    "el-tab-pane",
                    { staticClass: "tab", attrs: { name: "imovel" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("Imóvel  ")
                        ])
                      ]),
                      _vm.processo.tipo.codigo !== "REGULARIZACAO_URBANA" &&
                      _vm.processo.tipo.codigo !== "REURB_INDIVIDUAL"
                        ? _c(
                            "div",
                            [
                              !_vm.isRoraima
                                ? _c("informacoes-imovel", {
                                    attrs: {
                                      cadastroOriginal: _vm.cadastroOriginal,
                                      isOneroso:
                                        _vm.cadastroOriginal.tipo === "ONEROSO",
                                      isOnerosoGroup:
                                        _vm.cadastroOriginal.tipo ===
                                          "ONEROSO" ||
                                        _vm.cadastroOriginal.tipo ===
                                          "NAO_ONEROSO",
                                      compararImovel:
                                        _vm.compararRetificacoes.mudouImovelDTO,
                                      compararDestinacaoUsoImovel:
                                        _vm.compararRetificacoes
                                          .mudouDestinacaoUsoImovelDTO,
                                      destinacaoUsoImovel:
                                        _vm.destinacaoUsoImovel
                                    }
                                  })
                                : _c("informacoes-imovel-rr", {
                                    attrs: {
                                      cadastroOriginal: _vm.cadastroOriginal
                                    }
                                  }),
                              _vm.isProcessoFisico
                                ? _c("app-divider", {
                                    attrs: { label: "Dados do Registro" }
                                  })
                                : _vm._e(),
                              _vm.isProcessoFisico
                                ? _c("informacoes-registro-imovel", {
                                    attrs: {
                                      cadastroOriginal: _vm.cadastroOriginal
                                    }
                                  })
                                : _vm._e(),
                              _vm.imovel.documentos &&
                              _vm.imovel.documentos.length > 0
                                ? _c("listagem-documentos", {
                                    attrs: {
                                      documentos: _vm.imovel.documentos,
                                      protocoloCadastroOriginal:
                                        _vm.cadastroOriginal.protocolo,
                                      ownerDocumento: "IMOVEL",
                                      isDetalhes: true,
                                      interessado: _vm.interessado,
                                      tempoOcupacao: _vm.imovel.tempoOcupacao,
                                      compararDocumentos:
                                        _vm.compararRetificacoes.mudouImovelDTO
                                          .mudouDocumentosImovel,
                                      versaoCadastro: _vm.versaoCadastro,
                                      isCadastroPendente: _vm.isCadastroPendente
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("informacoes-imovel-reurb", {
                                attrs: {
                                  cadastroOriginal: _vm.cadastroOriginal,
                                  compararImovelReurb:
                                    _vm.compararRetificacoes.mudouImovelDTO
                                }
                              })
                            ],
                            1
                          )
                    ]
                  )
                : _vm._e(),
              !_vm.isPEAS &&
              !_vm.isReurb &&
              !_vm.isCCR &&
              !_vm.isBahia &&
              !_vm.isProcessoFisico &&
              !_vm.isGeoCadastro
                ? _c(
                    "el-tab-pane",
                    { staticClass: "tab", attrs: { name: "destinacaoUso" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("Destinação e uso do imóvel  ")
                        ])
                      ]),
                      _c("informacoes-destinacaoUsoImovel", {
                        attrs: {
                          destinacaoUsoImovel: _vm.destinacaoUsoImovel,
                          isOnerosoGroup:
                            _vm.cadastroOriginal.tipo === "ONEROSO" ||
                            _vm.cadastroOriginal.tipo === "NAO_ONEROSO",
                          protocoloCadastroOriginal:
                            _vm.cadastroOriginal.protocolo,
                          compararDestinacaoUsoImovel:
                            _vm.compararRetificacoes.mudouDestinacaoUsoImovelDTO
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isReurb &&
              !_vm.isCCR &&
              !_vm.isProcessoFisico &&
              _vm.hasGeoBa
                ? _c(
                    "el-tab-pane",
                    {
                      staticClass: "tab",
                      attrs: { name: "georreferenciamento" }
                    },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("Georreferenciamento  ")
                        ])
                      ]),
                      _vm.abaAtiva == "georreferenciamento" &&
                      !_vm.hasNotGeoReferenciamentoMa
                        ? _c("app-resumo-geo", {
                            attrs: {
                              localizacao: _vm.processo.geometria,
                              geo: _vm.georreferenciamento,
                              "id-mapa":
                                "mapaResumo" + (Math.random() * (10 - 0) + 0),
                              showMapa: _vm.naoPossuiGeorreferenciamento,
                              exibeDocumentos: false,
                              isVisualizarCadastro: true,
                              isGeoBeneficiario: false,
                              idCadastro: _vm.processo.numeroProtocolo,
                              isCadastroOff: true,
                              idProcesso: _vm.processo.id,
                              possuiCredenciadoGeo: _vm.possuiCredenciado(),
                              cruzamentoCamada: _vm.processo.cruzamentoCamada,
                              compararResumoGeo:
                                _vm.compararRetificacoes
                                  .mudouGeorreferenciamentoDTO
                            }
                          })
                        : _vm.isMaranhao &&
                          _vm.abaAtiva == "georreferenciamento" &&
                          _vm.hasNotGeoReferenciamentoMa
                        ? _c("span", [
                            _vm._v(
                              "Não foi informado nenhum dado durante o cadastro."
                            )
                          ])
                        : _vm._e(),
                      (_vm.georreferenciamento.documentos &&
                        _vm.georreferenciamento.documentos.length > 0) ||
                      (_vm.processo.documentosAutenticaveis &&
                        _vm.processo.documentosAutenticaveis.length > 0)
                        ? _c("listagem-documentos", {
                            attrs: {
                              documentos: _vm.georreferenciamento.documentos,
                              documentosGeo:
                                _vm.processo.documentosAutenticaveis,
                              protocoloCadastroOriginal:
                                _vm.cadastroOriginal.protocolo,
                              ownerDocumento: "GEO",
                              addMarginTop: false,
                              compararDocumentos:
                                _vm.compararRetificacoes
                                  .mudouGeorreferenciamentoDTO
                                  .mudouDocumentosGeorreferenciamento,
                              versaoCadastro: _vm.versaoCadastro,
                              isCadastroPendente: _vm.isCadastroPendente
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isReurb && !_vm.isGeoCadastro
                ? _c(
                    "el-tab-pane",
                    { staticClass: "tab", attrs: { name: "galeria" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("Documentos  ")
                        ])
                      ]),
                      _c("galeria", {
                        attrs: {
                          loading: _vm.loading,
                          srcList: _vm.galeria,
                          imovel: _vm.imovel,
                          interessado: _vm.interessado,
                          protocolo: _vm.protocoloReurb,
                          compararGaleria:
                            _vm.compararRetificacoes.mudouImovelDTO,
                          versaoCadastro: _vm.versaoCadastro
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isGeoCadastro
                ? _c(
                    "el-tab-pane",
                    { staticClass: "tab", attrs: { name: "termoCompromisso" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("Termo de compromisso  ")
                        ])
                      ]),
                      _c("informacoes-termo-compromisso", {
                        attrs: {
                          isReurb: _vm.isReurb,
                          isProcessoFisico: _vm.isProcessoFisico
                        }
                      }),
                      _vm.isReurb
                        ? _c("app-divider", { attrs: { label: "Assinatura" } })
                        : _vm._e(),
                      _vm.isReurb
                        ? _c("assinatura-mobile", {
                            attrs: {
                              assinatura: _vm.assinatura,
                              isAssinaturaInserida:
                                _vm.interessado.isAssinaturaInserida
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c01479f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c01479f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InformacoesCadastroOffline.vue
// module id = null
// module chunks = 